export default "__VITE_ASSET__BPeeAGle__"